module.exports = __webpack_public_path__ + "img/TR-mob.838f7280.jpg";